<template>
  <div
    class="
      full-height
      full-width
      is-flex
      is-flex-direction-column
      reset-password
    ">
    <b-loading v-model="checkingToken" />
    <header class="reset-password__header">
      <img
        src="@/assets/images/logo.svg"
        alt="Logo"
        class="reset-password__header--logo"
      />
    </header>
    <div class="
      full-width
      is-align-items-center
      is-flex
      is-flex-direction-column
      is-justify-content-center
    ">
      <div class="
        is-align-items-center
        is-flex
        is-flex-direction-column
        is-justify-content-center
        reset-password__content
      ">
        <h1 class="has-text-black has-text-weight-light is-size-3 mb-medium">
          重置密碼
        </h1>
        <div class="full-width mb-7">
          <b-field
            :message="getPasswordMsg"
            :type="{ 'is-danger': hasErrorMsgs('password') }"
            custom-class="has-text-black has-text-left"
            horizontal
            label="設定密碼"
          >
            <b-input
              :use-html5-validation="false"
              v-model="v$.form.password.$model"
              password-reveal
              autofocus
              type="password"
            />
          </b-field>
          <b-field
            :message="getErrorMsgs('confirmPassword')"
            :type="{ 'is-danger': hasErrorMsgs('confirmPassword') }"
            custom-class="has-text-black has-text-left"
            horizontal
            label="再次輸入密碼"
          >
            <b-input
              :use-html5-validation="false"
              v-model="v$.form.confirmPassword.$model"
              password-reveal
              type="password"
            />
          </b-field>
        </div>
        <b-button
          :disabled="updatingUser || (v$.form.$invalid && v$.form.$dirty)"
          :loading="updatingUser"
          :outlined="v$.form.$invalid"
          class="mb-4 mt-4"
          native-type="submit"
          type="is-primary"
          expanded
          @click="confirm">
          確定重置
        </b-button>
        <router-link replace to="/login">
          取消重置，前往登入頁面
        </router-link>
      </div>
    </div>
    <div class="is-justify-content-end is-flex">
      <img
        alt="Reset Password Image"
        class="reset-password__image"
        src="@/assets/images/reset-password.svg"
        width="646px"
      />
    </div>
  </div>
</template>

<script>
import ResetPassword from './ResetPassword';

export default ResetPassword;
</script>

<style lang="scss" scoped>
@import 'ResetPassword';
</style>
